import type { Filters } from 'brand_xo/CasinoFilters/types';

// Mirrors BrandXo::GamesPath (/games[/provider/:provider][/list/:list[/tag/:tag]]): fixed segment
// order, a tag only within a list, `name` stays a query param since it's free-text search, not a
// facet. Filter values already are the lowercase hyphenated slugs the path uses, and /casino/search
// takes them as they are.
export const SEGMENT_ORDER: (keyof Filters)[] = ['provider', 'list', 'tag'];

export const parseGamesPath = (pathname = ''): Filters => {
  const allSegments = pathname.split('/').filter(Boolean);
  const segments = allSegments[0] === 'games' ? allSegments.slice(1) : [];
  const filters: Filters = {};

  for (let i = 0; i < segments.length - 1; i += 2) {
    const key = segments[i] as keyof Filters;
    if (SEGMENT_ORDER.includes(key)) {
      filters[key] = segments[i + 1];
    }
  }

  return filters;
};

// A tag belongs to its list: another list drops it unless it comes with its own, the provider and
// the name stay.
export const mergeFilters = (filters: Filters, changes: Filters): Filters => {
  const newList = changes.list && changes.list !== filters.list;

  return { ...filters, ...changes, ...(newList ? { tag: changes.tag ?? '' } : {}) };
};

export const buildGamesPath = (filters: Filters): string => {
  const keys = SEGMENT_ORDER.filter((key) => filters[key] && (key !== 'tag' || filters.list));
  const segments = keys.flatMap((key) => [key, filters[key] as string]);

  return segments.length ? `/games/${segments.join('/')}` : '/';
};
